import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectItem } from 'primeng/api';
import { Nillable } from '@web/utils';
import { PrimengMultiselectDirective } from '../../../multiselect/directives/primeng-multiselect.directive';

@Component({
  selector: 'app-table-filter-multiselect',
  imports: [
    MultiSelectModule,
    PrimengMultiselectDirective,
    ReactiveFormsModule,
  ],
  templateUrl: './table-filter-multiselect.component.html',
  styleUrl: './table-filter-multiselect.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableFilterMultiselectComponent<Dictionary>
  implements OnInit, OnDestroy
{
  private readonly builder = inject(FormBuilder);

  @Input() public selectItems!: SelectItem<Dictionary>[];

  @Output() public readonly changes = new EventEmitter<Nillable<Dictionary>>();

  public control!: FormControl<Nillable<Dictionary>>;

  private readonly destroy$ = new Subject<void>();

  public ngOnInit(): void {
    this.configureControl();
    this.configureValueChangesSource();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  private configureControl(): void {
    this.control = this.builder.control(null);
  }

  private configureValueChangesSource(): void {
    this.control.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => this.changes.emit(value));
  }
}
